export default __webpack_public_path__ + "static/media/chocho_s.4d16bdeb.jpg";